var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowAutomatedCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#5F11EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5486_2574",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5486_2574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6113 47.7783H26.5283C28.056 50.2316 30.0162 52.1411 32.4092 53.5068C34.8027 54.8724 37.398 55.5556 40.1943 55.5557C43.4998 55.5557 46.4836 54.5972 49.1455 52.6807C51.8075 50.764 53.6661 48.2356 54.7217 45.0967L57.4443 45.708C56.2313 49.4858 54.0417 52.535 50.875 54.8545C47.7084 57.1739 44.1479 58.333 40.1943 58.333C36.9537 58.333 33.97 57.5808 31.2432 56.0762C28.5165 54.5717 26.2499 52.4443 24.4443 49.6943V54.9717H21.667V45H31.6113V47.7783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.667 47.6152L39 43.4619H37.4443V49H35.2227V43.4619H33.2227C32.6116 43.4619 32.0877 43.236 31.6523 42.7842C31.2172 42.3321 31 41.7879 31 41.1533V37.4619C31 36.8275 31.2175 36.284 31.6523 35.832C32.0877 35.3802 32.6115 35.1543 33.2227 35.1543H39L45.667 31V47.6152ZM39.5996 37.4619H33.2227V41.1533H39.5996L43.4443 43.5312V35.085L39.5996 37.4619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 34.6689C47.6 35.2228 48.0835 35.8982 48.4502 36.6943C48.8168 37.4904 49 38.3616 49 39.3076C49 40.2537 48.8168 41.1248 48.4502 41.9209C48.0835 42.7171 47.6 43.3924 47 43.9463V34.6689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.917 30.2637C26.9725 31.4767 26.2128 32.7618 25.6387 34.1182C25.0649 35.4746 24.6995 36.8796 24.542 38.333H21.75C21.9444 36.4535 22.3887 34.669 23.083 32.9795C23.7774 31.2898 24.7271 29.7227 25.9307 28.2783L27.917 30.2637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9443 28.1943C55.2035 29.6757 56.1993 31.2799 56.9307 33.0068C57.6623 34.7334 58.1019 36.509 58.25 38.333H55.4717C55.3328 36.9165 54.9577 35.5116 54.3467 34.1182C53.7356 32.7248 52.9491 31.4211 51.9863 30.208L53.9443 28.1943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3887 24.5283C36.9538 24.6672 35.5696 25.0183 34.2363 25.583C32.903 26.1477 31.5742 26.9307 30.25 27.9307L28.292 25.917C29.7828 24.6948 31.3749 23.7333 33.0693 23.0342C34.7638 22.3353 36.537 21.9075 38.3887 21.75V24.5283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.667 21.75C43.5465 21.9167 45.3309 22.3476 47.0205 23.042C48.7102 23.7364 50.2773 24.6948 51.7217 25.917L49.7637 27.9307C48.5509 26.9679 47.2658 26.1947 45.9092 25.6113C44.553 25.0281 43.139 24.6672 41.667 24.5283V21.75Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowAutomatedCampaigns);
export default __webpack_public_path__ + "static/media/icon-flow-automated-campaigns.103fc43eda82ec735388f675324380a2.svg";
export { ForwardRef as ReactComponent };